/**
 * 1.3.0 portal strings, stream P1: the portal's sign-in screens (sign-in, the two-step code, enrolment, forgot
 * password, set a password from an invitation or a reset link, the account page) and the identity emails
 * (email.portal_invitation.*, email.portal_password_reset.*, email.portal_two_step_reset.*). P1's file.
 */
export const IDENTITY_STRINGS = {
  'identity.signIn': 'Sign in',
  'identity.signingIn': 'Signing in…',
  'identity.signOut': 'Sign out',
  'identity.signInTitle': 'Sign in to {portalName}',
  'identity.signInLede': 'Use the email address your PRISM contact invited.',
  'identity.email': 'Email',
  'identity.password': 'Password',
  'identity.code': 'Code from your authenticator app',
  'identity.forgot': 'Forgot your password?',
  'identity.badCredentials': 'The email or password is not right.',
  'identity.tooMany': 'Too many attempts. Try again in {seconds} seconds.',
  'identity.backToSignIn': 'Back to sign-in',
  'identity.continue': 'Continue',
  'identity.disabledPortal': 'The portal is not open at the moment.',

  'identity.code.title': 'Two-step sign-in',
  'identity.code.lede': 'Enter the 6-digit code from your authenticator app.',
  'identity.code.useRecovery': 'Use a recovery code instead',
  'identity.code.useApp': 'Use the authenticator app instead',
  'identity.code.recovery': 'Recovery code',
  'identity.code.wrong': 'That code is not right.',
  'identity.code.verify': 'Verify',

  'identity.enrol.title': 'Set up two-step sign-in',
  'identity.enrol.lede': 'Your account needs a code from an authenticator app (such as Google Authenticator, Microsoft Authenticator or 1Password) at each sign-in.',
  'identity.enrol.scan': 'Scan this QR code with the app, or enter the key by hand.',
  'identity.enrol.key': 'Key',
  'identity.enrol.confirm': 'Enter the code the app shows to finish.',
  'identity.enrol.start': 'Start',
  'identity.enrol.recoveryTitle': 'Your recovery codes',
  'identity.enrol.recoveryLede': 'Keep these somewhere safe. Each code signs you in once if you lose your phone. They are not shown again.',
  'identity.enrol.done': 'I have saved them',

  'identity.forgot.title': 'Reset your password',
  'identity.forgot.lede': 'Enter your email address. If it belongs to an account, we send a link to choose a new password.',
  'identity.forgot.send': 'Send the link',
  'identity.forgot.sent': 'If the address belongs to an account, a link is on its way. It works for one hour.',

  'identity.setPassword.title': 'Choose your password',
  'identity.setPassword.inviteLede': 'Welcome. Choose a password for your account to finish the invitation.',
  'identity.setPassword.resetLede': 'Choose a new password. You are signed out everywhere else.',
  'identity.setPassword.new': 'New password',
  'identity.setPassword.repeat': 'Repeat the password',
  'identity.setPassword.hint': 'At least 12 characters. A few words together are easy to remember.',
  'identity.setPassword.mismatch': 'The passwords do not match.',
  'identity.setPassword.save': 'Save the password',
  'identity.setPassword.saved': 'Your password is saved. Sign in with it.',
  'identity.setPassword.badLink': 'This link is not valid any more. Ask for a new one.',

  'identity.account.title': 'Your account',
  'identity.account.company': 'Company',
  'identity.account.passwordTitle': 'Password',
  'identity.account.current': 'Current password',
  'identity.account.change': 'Change the password',
  'identity.account.changed': 'Your password is changed. Other sessions are signed out.',
  'identity.account.twoStepTitle': 'Two-step sign-in',
  'identity.account.twoStepOn': 'On: each sign-in asks for a code from your authenticator app.',
  'identity.account.twoStepOff': 'Off: sign-in asks only for your password.',
  'identity.account.twoStepRequired': 'Your organisation requires it.',
  'identity.account.twoStepEnable': 'Turn on two-step sign-in',
  'identity.account.twoStepDisable': 'Turn off two-step sign-in',
  'identity.account.twoStepDisabled': 'Two-step sign-in is off.',
  'identity.account.signOutTitle': 'Sign out',
  'identity.account.signOutLede': 'Sign out of the portal on this device.',

  'identity.error.WEAK_PASSWORD': 'Choose a longer, less predictable password.',
  'identity.error.WRONG_PASSWORD': 'Your current password is not right.',
  'identity.error.SESSION_IDLE': 'You were signed out after a while without activity. Sign in again.',

  'email.portal_invitation.subject': 'You are invited to {portalName}',
  'email.portal_invitation.body': 'Hello {name},\n\nYou are invited to {portalName} for {company}, to deliver and upload files to us.\n\nChoose your password here (the link works until {expires}):\n{link}\n\nIf you did not expect this, ignore this message.',
  'email.portal_password_reset.subject': 'Reset your {portalName} password',
  'email.portal_password_reset.body': 'Hello {name},\n\nSomeone asked to reset your {portalName} password. Choose a new one here (the link works for one hour):\n{link}\n\nIf it was not you, ignore this message: your password stays as it is.',
  'email.portal_two_step_reset.subject': 'Two-step sign-in reset on {portalName}',
  'email.portal_two_step_reset.body': 'Hello {name},\n\nYour two-step sign-in on {portalName} was reset by your PRISM contact. At your next sign-in you set it up again with your authenticator app:\n{link}\n\nIf you did not ask for this, tell your PRISM contact.',
} as const;
